import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

 const Preroll = (props) => (
   <SvgIcon {...props}>
      <g>
        
          <polygon fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
          22,9.857 2,10.393 2,13.607 22,14.143 	"/>
        
          <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="15.214" y1="10.214" x2="12.714" y2="13.786"/>
        
          <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinejoin="round" strokeMiterlimit="10" x1="8.429" y1="10.214" x2="5.571" y2="13.786"/>
        
          <line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinejoin="round" strokeMiterlimit="10" x1="18.786" y1="9.857" x2="18.786" y2="14.143"/>
      </g>
   </SvgIcon>
);

export default Preroll;



// WEBPACK FOOTER //
// ./src/icons/types/Preroll.jsx